import { JobOpeningsPage } from "./job-openings";

export default function Jobs() {
  return (
    <div>
      <JobOpeningsPage />
    </div>
  );
}
